/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import uuidv4 from 'uuid/v4';


const mulberry32 = (state) =>
{
  return () =>
  {
    const bytes = new Array(16);

    for (let i = 0; i < 16; ++i)
    {
      state = (state + 0x6D2B79F5) | 0;

      let t = Math.imul(state ^ (state >>> 15), 1 | state);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;

      bytes[i] = ((t ^ (t >>> 14)) >>> 0) & 0xff;
    }

    return bytes;
  };
};


const hashSeed = (value) =>
{
  let hash = 0;

  for (let i = 0; i < value.length; ++i)
  {
    hash = (Math.imul(hash, 31) + value.charCodeAt(i)) | 0;
  }

  return hash;
};


let rng = null;


export const withSeed = (value, callback) =>
{
  const previous = rng;

  rng = mulberry32(hashSeed(String(value)));

  try
  {
    return callback();
  }
  finally
  {
    rng = previous;
  }
};


export default () =>
{
  return uuidv4(rng ? { rng } : undefined);
};
